import React, {
	// 	//useState,
	useEffect,
} from 'react';

//import {
//	useSelector
//useDispatch,
//} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';

const Loading = (props) => {
	//const [loading, setVisible] = useState(true);			//the selected product - state variable
	//const loading = useSelector(state => state.messages);	// get from redux store
	//var messages = []
	useEffect(() => {
		//	const messages = useSelector(state => state.messages);	// get from redux store
	}, []);
	//const store = useStore()
	//const messages = []

	//state = { visible: true }
	//const { messages, header } = this.props
	if (props.loading) {
		return (
			<Spinner
				animation="border"
				size={props.size}
				variant="info"
				style={{ marginTop: '0.3em' }}
			/>
		);
	} else {
		return null;
	}
};

export default Loading;
